import moment from "moment";

export const initialStateDashboard = {
  detailType: "",
  cityId: 0,
  fromDate: null,
  toDate: null,
};

export const initialStateDashboardPayout = {
  month: moment().subtract(1, "months").endOf("month").format("M"),
  year: moment().year().toString(),
  page: 1,
  rows: 3,
  sortDirection: "desc",
  SortColumn: "Amount",
  providerId: 0,
};

export const initialStateDashboardCoverage = {
  page: 1,
  rows: 3,
  providerIds: "",
  visitSupport: "",
  pincodeOrCity: "",
  startDate: moment().subtract(15, "days").format("YYYY-MM-DD"),
  endDate: moment(new Date()).format("YYYY-MM-DD"),
  sortDirection: "desc",
};

export const customYAxisFormatter = (value) => {
  if (value >= 10000000) {
    // Format in crores (e.g., 1 crore = 10,000,000)
    return (value / 10000000).toFixed(1) + " Cr";
  } else if (value >= 100000) {
    // Format in lakhs (e.g., 1 lakh = 100,000)
    return (value / 100000).toFixed(1) + " L";
  } else if (value >= 1000) {
    // Format in thousands
    return (value / 1000).toFixed(1) + " K";
  }
  return value; // Default formatting for smaller values
};
